const StartupType = {
  GET_HISTORIES: 'GET_HISTORIES',
  GET_HISTORY: 'GET_HISTORY',
  CREATE_HISTORY: 'CRAETE_HISTORY',
  UPDATE_HISTORY: 'UPDATE_HISTORY',
  DELETE_HISTORY: 'DELETE_HISTORY',
}

export default StartupType
